import { createSlice } from "@reduxjs/toolkit"

const futureSchedulesSlice = createSlice({
	name: "futureSchedules",
	initialState: {
		data: {}, // Object to hold date -> {patients: [], nurses: []} mapping
		status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
		error: null
	},
	reducers: {
		setFutureSchedulesData: (state, action) => {
			// Merge new data with existing data instead of replacing
			state.data = { ...state.data, ...action.payload }
			state.status = "succeeded"
		},
		setFutureSchedulesLoading: state => {
			state.status = "loading"
		},
		setFutureSchedulesError: (state, action) => {
			state.status = "failed"
			state.error = action.payload
		},
		updateNurseScheduleForDate: (state, action) => {
			const { date, nurses } = action.payload
			if (state.data[date]) {
				state.data[date].nurses = nurses
			} else {
				state.data[date] = {
					patients: [],
					nurses: nurses
				}
			}
		}
	}
})

export const {
	setFutureSchedulesData,
	setFutureSchedulesLoading,
	setFutureSchedulesError,
	updateNurseScheduleForDate
} = futureSchedulesSlice.actions

export default futureSchedulesSlice.reducer
